import { Map } from 'immutable';
import { actionTypes as CreatePlyTypeDialogActionsType } from '../../../actions/Administration/MatSettingsPage/Dialogs/createPlyTypeDialogActions.js';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: null,
};

export default function (state = Map(defaultState), action) {
  switch (action.type) {
    case CreatePlyTypeDialogActionsType.CREATE_PLY_TYPE_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show', true);

    case CreatePlyTypeDialogActionsType.CREATE_PLY_TYPE_DIALOG_HIDE:
      return Map(defaultState);

    case CreatePlyTypeDialogActionsType.CREATE_PLY_TYPE_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set('loading', true);

    case CreatePlyTypeDialogActionsType.CREATE_PLY_TYPE_DIALOG_SUBMIT_FINISHED:
      return state.set('loading', false);

    case CreatePlyTypeDialogActionsType.CREATE_PLY_TYPE_DIALOG_FETCH_DATA_READY:
      return state.set('dialogData', action.payload);

    default:
      return state;
  }
}
